export const availableDaysValidator = (value) => {
    if (!value || !value.days) return false;

    // Check if at least one day is selected
    const days = value.days;
    const selectedDays = Object.values(days).filter(day => day.value === true);

    return selectedDays.length > 0;
};
